import React, { useState, useContext } from "react"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { SelectButton } from "primereact/selectbutton"
import { Button } from "primereact/button"
import PropTypes from "prop-types"

import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/FilterHeader.module.css"

export default function AuditLogFilters(props) {
  const { session } = useContext(UserContext)

  const { selectedFilters, filterOptions, handleOnChange, handleReset } = props

  const [isExpanded, setIsExpanded] = useState(true)

  const renderFiltersByType = () => {
    const dateFilters = (
      <>
        <div className={styles["filter-field"]}>
          <label htmlFor="startDate">Start Date:</label>
          <Calendar
            id="startDate"
            value={selectedFilters["startDate"]}
            onChange={(e) => handleOnChange(e)}
            placeholder="Start Date"
          />
        </div>
        <div className={styles["filter-field"]}>
          <label htmlFor="endDate">End Date:</label>
          <Calendar
            id="endDate"
            value={selectedFilters["endDate"]}
            onChange={(e) => handleOnChange(e)}
            placeholder="End Date"
          />
        </div>
      </>
    )
    switch (selectedFilters.auditType) {
      case "participant": {
        return (
          <div className={styles["filter-fields"]}>
            {dateFilters}
            <div className={styles["filter-field"]}>
              <label htmlFor="participant">Participant: </label>
              <Dropdown
                id="participant"
                value={selectedFilters["participant"]}
                options={filterOptions["participant"]}
                onChange={(e) => handleOnChange(e)}
                placeholder="Select a Participant"
              />
            </div>
            <div className={styles["filter-field"]}>
              <label htmlFor="staffFacilitator">Facilitator</label>
              <Dropdown
                id="staffFacilitator"
                value={selectedFilters["staffFacilitator"]}
                options={filterOptions["staffFacilitator"]}
                onChange={(e) => handleOnChange(e)}
                placeholder="Select a Facilitator"
              />
            </div>
          </div>
        )
      }
      case "staff": {
        return (
          <>
            {dateFilters}
            <div className={styles["filter-field"]}>
              <label htmlFor="staffMember">Staff Member:</label>
              <Dropdown
                id="staffMember"
                value={selectedFilters["staffMember"]}
                options={filterOptions["staffFacilitator"]}
                onChange={(e) => handleOnChange(e)}
                placeholder="Select a Staff Member"
              />
            </div>
            <div className={styles["filter-field"]}>
              <label htmlFor="staffFacilitator">Facilitator:</label>
              <Dropdown
                id="staffFacilitator"
                value={selectedFilters["staffFacilitator"]}
                options={filterOptions["staffFacilitator"]}
                onChange={(e) => handleOnChange(e)}
                placeholder="Select a Facilitator"
              />
            </div>
          </>
        )
      }
      case "organization": {
        return (
          <>
            {dateFilters}
            <div className={styles["filter-field"]}>
              <label htmlFor="staffFacilitator">Staff Facilitator:</label>
              <Dropdown
                id="staffFacilitator"
                value={selectedFilters["staffFacilitator"]}
                options={filterOptions["staffFacilitator"]}
                onChange={(e) => handleOnChange(e)}
                placeholder="Select a Facilitator"
              />
            </div>
          </>
        )
      }
      case "enterprise":
      case "system": {
        return (
          <>
            {dateFilters}
            <div className={styles["filter-field"]}>
              <label htmlFor="organization">Organization:</label>
              <Dropdown
                id="organization"
                value={selectedFilters["organization"]}
                options={filterOptions["organization"]}
                onChange={(e) => handleOnChange(e)}
                placeholder="Select an Organization"
              />
            </div>
            <div className={styles["filter-field"]}>
              <label htmlFor="staffFacilitator">Staff Facilitator:</label>
              <Dropdown
                id="staffFacilitator"
                value={selectedFilters["staffFacilitator"]}
                options={filterOptions["staffFacilitatorByEnt"]}
                onChange={(e) => handleOnChange(e)}
                placeholder="Select a Facilitator"
              />
            </div>
          </>
        )
      }
      default:
        return null
    }
  }

  const handleSelectButtonOpts = () => {
    const currentStaffRole = session?.user?.staff_role
    const allFilterOptions = filterOptions["auditType"] || []
    return allFilterOptions.filter(({ leastRoleAccess }) => {
      return currentStaffRole <= leastRoleAccess
    })
  }

  return (
    <div className="filters-wrapper">
      <SelectButton
        id="auditType"
        value={selectedFilters["auditType"]}
        options={handleSelectButtonOpts()}
        onChange={(e) => handleOnChange(e)}
      />

      <div className={styles["filter-container"]}>
        <div className={styles["filter-header"]}>
          <h3>Filter Options</h3>
          <Button
            icon={isExpanded ? "pi pi-chevron-up" : "pi pi-chevron-down"}
            onClick={() => setIsExpanded(!isExpanded)}
            className={styles["expand-button"]}
          />
        </div>

        {isExpanded && (
          <>
            <div className={styles["filter-fields"]}>
              {renderFiltersByType()}
            </div>
            <div className={styles["filter-actions"]}>
              <Button
                label="Reset Filters"
                icon="pi pi-refresh"
                onClick={handleReset}
                className={styles["clear-button"]}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

AuditLogFilters.propTypes = {
  selectedFilters: PropTypes.shape({
    auditType: PropTypes.string.isRequired,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    participant: PropTypes.string,
    staffFacilitator: PropTypes.string,
    staffMember: PropTypes.string,
    organization: PropTypes.string,
  }).isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  filterOptions: PropTypes.shape({
    auditType: PropTypes.array.isRequired,
    participant: PropTypes.array,
    staffFacilitator: PropTypes.array,
    staffMember: PropTypes.array,
    organization: PropTypes.array,
  }).isRequired,
}
